(function () {
  function initHeroSlider(section) {
    var track = section.querySelector(".hs-slider__track");
    if (!track || track.dataset.hsReady === "true") return;

    var slides = Array.prototype.slice.call(track.querySelectorAll(".hs-slide"));
    var dots = Array.prototype.slice.call(section.querySelectorAll(".hs-slider__dot"));
    var prevBtn = section.querySelector("[data-slider-prev]");
    var nextBtn = section.querySelector("[data-slider-next]");
    var activeIndex = 0;

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = activeIndex === 0;
      if (nextBtn) nextBtn.disabled = activeIndex === slides.length - 1;
      dots.forEach(function (dot, index) {
        dot.classList.toggle("is-active", index === activeIndex);
      });
    }

    function goToSlide(index) {
      if (!slides[index]) return;
      activeIndex = index;
      var slideLeft = slides[index].offsetLeft;
      track.scrollTo({ left: slideLeft, behavior: "smooth" });
      updateButtons();
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goToSlide(Math.max(0, activeIndex - 1));
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goToSlide(Math.min(slides.length - 1, activeIndex + 1));
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        goToSlide(index);
      });
    });

    track.addEventListener("scroll", function () {
      var slideWidth = slides[0] ? slides[0].offsetWidth : 1;
      if (!slideWidth) return;
      var idx = Math.round(track.scrollLeft / slideWidth);
      if (idx !== activeIndex && idx >= 0 && idx < slides.length) {
        activeIndex = idx;
        updateButtons();
      }
    });

    var isDown = false;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener("pointerdown", function (event) {
      isDown = true;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener("pointermove", function (event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      track.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      var slideWidth = slides[0] ? slides[0].offsetWidth : 1;
      activeIndex = Math.round(track.scrollLeft / slideWidth);
      activeIndex = Math.max(0, Math.min(slides.length - 1, activeIndex));
      goToSlide(activeIndex);
    }

    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("pointerleave", endDrag);

    track.dataset.hsReady = "true";
    updateButtons();
  }

  function initFaq(section) {
    var items = Array.prototype.slice.call(section.querySelectorAll(".hs-faq__item"));
    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector(".hs-faq__trigger");
      var content = item.querySelector(".hs-faq__content");
      if (!trigger || !content || trigger.dataset.hsReady === "true") return;

      trigger.addEventListener("click", function () {
        var expanded = trigger.getAttribute("aria-expanded") === "true";
        trigger.setAttribute("aria-expanded", expanded ? "false" : "true");
        content.style.maxHeight = expanded ? "0px" : content.scrollHeight + "px";
        var icon = trigger.querySelector(".hs-faq__icon");
        if (icon) icon.textContent = expanded ? "+" : "−";
      });

      trigger.dataset.hsReady = "true";
    });
  }

  function initSmoothScroll(root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('a[href^="#"]'));
    links.forEach(function (link) {
      if (link.dataset.hsReady === "true") return;
      link.addEventListener("click", function (event) {
        var href = link.getAttribute("href");
        if (!href || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      link.dataset.hsReady = "true";
    });
  }

  function initSizeFinder(section) {
    if (!section || section.dataset.hsReady === "true") return;
    var form = section.querySelector("[data-size-finder-form]");
    if (!form) return;

    var input = form.querySelector("[data-home-size-input]");
    var range = form.querySelector("[data-home-size-range]");
    var resultWrap = section.querySelector("[data-size-result]");
    var resultTitle = section.querySelector("[data-size-result-title]");
    var resultCopy = section.querySelector("[data-size-result-copy]");
    var resultBtn = section.querySelector("[data-size-result-btn]");
    var output = form.querySelector("[data-home-size-output]");

    if (!input || !resultWrap || !resultTitle || !resultCopy || !resultBtn) return;

    function getRecommendation(size) {
      if (size <= 1500) return "signature";
      if (size <= 3000) return "luxury";
      return "estate";
    }

    function applyRecommendation(size) {
      var key = getRecommendation(size);
      var title = form.dataset[key + "Title"] || "";
      var text = form.dataset[key + "Text"] || "";
      var link = form.dataset[key + "Link"] || "#home-scenting-plans";
      var cta = form.dataset[key + "Cta"] || "View plan";

      resultTitle.textContent = title;
      resultCopy.textContent = text;
      resultBtn.textContent = cta;
      resultBtn.setAttribute("href", link);
      resultWrap.hidden = false;

      document.querySelectorAll(".hs-plan.is-recommended").forEach(function (plan) {
        plan.classList.remove("is-recommended");
      });
      document.querySelectorAll('[data-plan-key="' + key + '"]').forEach(function (plan) {
        plan.classList.add("is-recommended");
      });
    }

    function syncAndPreview(value) {
      if (!Number.isFinite(value) || value <= 0) return;
      if (output) output.textContent = String(value);
      if (range && String(range.value) !== String(value)) range.value = String(value);
      if (String(input.value) !== String(value)) input.value = String(value);
      applyRecommendation(value);
    }

    input.addEventListener("input", function () {
      var value = parseInt(input.value || "0", 10);
      if (Number.isNaN(value)) return;
      syncAndPreview(value);
    });

    if (range) {
      range.addEventListener("input", function () {
        var value = parseInt(range.value || "0", 10);
        if (Number.isNaN(value)) return;
        syncAndPreview(value);
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var size = parseInt(input.value || "0", 10);
      if (Number.isNaN(size) || size <= 0) return;
      applyRecommendation(size);
      resultWrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });

    var initial = parseInt(input.value || "0", 10);
    if (!Number.isNaN(initial) && initial > 0) {
      syncAndPreview(initial);
    }

    section.dataset.hsReady = "true";
  }

  function initAll(scope) {
    var root = scope || document;
    var heroSections = root.querySelectorAll(".hs-hero");
    heroSections.forEach(initHeroSlider);

    var faqSections = root.querySelectorAll(".hs-faq");
    faqSections.forEach(function (faqSection) {
      initFaq(faqSection);
    });

    var landingScopes = root.querySelectorAll(".hs-section");
    landingScopes.forEach(initSmoothScroll);

    var sizeFinderSections = root.querySelectorAll(".hs-size-finder");
    sizeFinderSections.forEach(initSizeFinder);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
